const NativeModules = process.env;
export const Environment = NativeModules || {}
export default Environment;
